if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;

        this.variantData = this.getVariantData();

        this.init();
        this.syncSellingPlan();
        try {
          this.syncQuantityFromPackSize();
        } catch (error) {
          console.log('Error calling syncQuantityFromPackSize:', error);
        }
        
        // Sync quantity right before form submission to ensure it's up to date
        if (this.productForm) {
          this.productForm.addEventListener('submit', (e) => {
            this.syncQuantityBeforeSubmit();
          }, { capture: true });
        }
        this.select.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncSellingPlan() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return;

        const stickySellingPlanInput = this.querySelector('input[name="selling_plan"]');
        if (!stickySellingPlanInput) return;

        // Function to sync selling plan from main form to sticky form
        const updateSellingPlan = () => {
          let sellingPlanValue = '';

          // First, check if one-time purchase is selected
          const oneTimeSelected = mainForm.querySelector('[data-one-time], [data-onetime], .bundleapp-plan-selector-group--selected[data-one-time], input[value=""]:checked, input[value="0"]:checked, [class*="one-time"]:checked, [class*="onetime"]:checked');
          if (oneTimeSelected) {
            // One-time purchase is selected, clear selling plan
            stickySellingPlanInput.value = '';
            return;
          }

          // Check for one-time purchase button/option that's active
          const oneTimeButtons = mainForm.querySelectorAll('[class*="one-time"], [class*="onetime"], [data-plan-type="one-time"], [data-plan-type="onetime"]');
          let isOneTimeActive = false;
          oneTimeButtons.forEach(btn => {
            if (btn.classList.contains('active') || btn.classList.contains('selected') || btn.getAttribute('aria-selected') === 'true' || btn.checked) {
              isOneTimeActive = true;
            }
          });
          if (isOneTimeActive) {
            stickySellingPlanInput.value = '';
            return;
          }

          // Method 1: Direct input field (standard Shopify)
          const mainSellingPlanInput = mainForm.querySelector('input[name="selling_plan"]');
          if (mainSellingPlanInput) {
            // If the input exists but is empty or has no value, it's one-time purchase
            if (!mainSellingPlanInput.value || mainSellingPlanInput.value === '' || mainSellingPlanInput.value === '0') {
              stickySellingPlanInput.value = '';
              return;
            }
            sellingPlanValue = mainSellingPlanInput.value;
          }

          // Method 2: Check for Loop/Awtomic selected plan groups
          const selectedPlanGroup = mainForm.querySelector('.bundleapp-plan-selector-group--selected');
          if (selectedPlanGroup && !selectedPlanGroup.hasAttribute('data-one-time')) {
            const planSelect = selectedPlanGroup.querySelector('select.bundleapp-plan-selector-select');
            if (planSelect && planSelect.value) {
              sellingPlanValue = planSelect.value;
            }
            const planRadio = selectedPlanGroup.querySelector('input[name="plan"]:checked');
            if (planRadio && planRadio.value) {
              sellingPlanValue = planRadio.value;
            }
          }

          // Method 3: Check for Loop-specific selectors (various possible names)
          if (!sellingPlanValue) {
            const loopSelectors = [
              'input[name*="selling_plan"]',
              'input[id*="selling_plan"]',
              'input[data-selling-plan]',
              'input[name*="sellingPlan"]',
              'select[name*="selling_plan"]',
              'select[name*="sellingPlan"]'
            ];
            for (const selector of loopSelectors) {
              const loopInput = mainForm.querySelector(selector);
              if (loopInput && loopInput.value) {
                sellingPlanValue = loopInput.value;
                break;
              }
            }
          }

          // Method 4: Check for Loop widget data attributes
          if (!sellingPlanValue) {
            const loopWidget = mainForm.querySelector('[data-loop-subscription], [data-loop-plan], [class*="loop"]');
            if (loopWidget) {
              const planId = loopWidget.getAttribute('data-selling-plan') || 
                            loopWidget.getAttribute('data-loop-plan') ||
                            loopWidget.getAttribute('data-selected-plan');
              if (planId) {
                sellingPlanValue = planId;
              }
            }
          }

          // Method 5: Check entire form for any selling plan related inputs
          if (!sellingPlanValue) {
            const allInputs = mainForm.querySelectorAll('input, select');
            for (const input of allInputs) {
              const name = (input.name || '').toLowerCase();
              const id = (input.id || '').toLowerCase();
              if ((name.includes('selling') && name.includes('plan')) || 
                  (id.includes('selling') && id.includes('plan'))) {
                if (input.value) {
                  sellingPlanValue = input.value;
                  break;
                }
              }
            }
          }

          // Update sticky form with found value
          if (sellingPlanValue) {
            stickySellingPlanInput.value = sellingPlanValue;
          }
        };

        // Update immediately
        updateSellingPlan();

        // Watch for changes periodically (until Loop form is loaded)
        const checkInterval = setInterval(() => {
          updateSellingPlan();
        }, 500);

        // Stop checking after 30 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
        }, 30000);

        // Listen for form changes
        if (mainForm) {
          mainForm.addEventListener('change', updateSellingPlan);
          mainForm.addEventListener('input', updateSellingPlan);
          mainForm.addEventListener('click', updateSellingPlan); // Loop might use clicks
        }

        // Watch for main selling plan input changes
        const mainSellingPlanInput = mainForm.querySelector('input[name="selling_plan"]');
        if (mainSellingPlanInput) {
          mainSellingPlanInput.addEventListener('change', updateSellingPlan);
          // Use mutation observer for value changes
          const observer = new MutationObserver(updateSellingPlan);
          observer.observe(mainSellingPlanInput, { 
            attributes: true, 
            attributeFilter: ['value'],
            childList: false,
            subtree: false
          });
        }

        // Listen for Loop-specific events
        const loopEvents = [
          'loop:plan:selected',
          'loop:subscription:selected',
          'bundleapp:plan:selected',
          'subscription:selected',
          'sellingPlan:changed'
        ];
        loopEvents.forEach(eventName => {
          document.addEventListener(eventName, (event) => {
            if (event.detail) {
              const planId = event.detail.sellingPlanId || 
                           event.detail.planId || 
                           event.detail.selling_plan ||
                           event.detail.value;
              if (planId) {
                stickySellingPlanInput.value = planId;
              }
            }
            updateSellingPlan();
          });
        });

        // Watch for clicks on subscription options (Loop might use click events)
        const subscriptionButtons = mainForm.querySelectorAll(
          '[class*="subscription"], [class*="plan"], [data-subscription], [data-plan]'
        );
        subscriptionButtons.forEach(button => {
          button.addEventListener('click', () => {
            setTimeout(updateSellingPlan, 100); // Small delay to let Loop update
          });
        });
      }

      syncQuantityBeforeSubmit() {
        try {
          const stickyQuantityInput = this.querySelector('input[name="quantity"]');
          if (!stickyQuantityInput) return;

          // Get the main form's quantity input value
          const mainQuantityInput = document.querySelector(`.main-product-form[data-product-id="${this.productId}"] input[name="quantity"]`);
          if (mainQuantityInput && mainQuantityInput.value) {
            const mainQty = parseInt(mainQuantityInput.value, 10);
            if (mainQty > 0 && mainQty <= 100) {
              stickyQuantityInput.value = mainQty;
            }
          } else {
            // Fallback: check pack selector radio
            const packSelectorRadio = document.querySelector(`.main-product-form[data-product-id="${this.productId}"] input[name="pack_selector"]:checked`) ||
                                     document.querySelector(`.main-product-form[data-product-id="${this.productId}"] .pack-selector-radio:checked`);
            if (packSelectorRadio && packSelectorRadio.value) {
              const packValue = parseInt(packSelectorRadio.value, 10);
              if (packValue > 0 && packValue <= 100) {
                stickyQuantityInput.value = packValue;
              }
            }
          }
        } catch (error) {
          console.log('Error syncing quantity before submit:', error);
        }
      }

      syncQuantityFromPackSize() {
        try {
          const stickyQuantityInput = this.querySelector('input[name="quantity"]');
          if (!stickyQuantityInput) return;

          const updateQuantity = () => {
            try {
              let quantity = 1;
              
              // Method 1: Check for pack selector radio buttons (primary method)
              // Try multiple selectors: by name, by class, and by direct query
              const packSelectorRadio = document.querySelector(`.main-product-form[data-product-id="${this.productId}"] input[name="pack_selector"]:checked`) ||
                                       document.querySelector(`.main-product-form[data-product-id="${this.productId}"] .pack-selector-radio:checked`) ||
                                       document.querySelector(`input[name="pack_selector"]:checked`) ||
                                       document.querySelector(`.pack-selector-radio:checked`);
              
              if (packSelectorRadio && packSelectorRadio.value) {
                const packValue = parseInt(packSelectorRadio.value, 10);
                if (packValue > 0 && packValue <= 100) {
                  quantity = packValue;
                }
              } else {
                // Method 2: Check the main form's quantity input (this is updated by the pack selector script)
                const mainQuantityInput = document.querySelector(`.main-product-form[data-product-id="${this.productId}"] input[name="quantity"]`) ||
                                        document.querySelector(`.main-product-form input[name="quantity"]`);
                
                if (mainQuantityInput && mainQuantityInput.value) {
                  const mainQty = parseInt(mainQuantityInput.value, 10);
                  if (mainQty > 0 && mainQty <= 100) {
                    quantity = mainQty;
                  }
                }
              }

              // Update sticky quantity input
              const currentQty = parseInt(stickyQuantityInput.value) || 1;
              if (currentQty !== quantity) {
                stickyQuantityInput.value = quantity;
                stickyQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } catch (error) {
              console.log('Error updating quantity:', error);
            }
          };

          // Update immediately
          updateQuantity();

          // Listen for changes
          const handleChange = () => {
            try {
              updateQuantity();
            } catch (error) {
              console.log('Error in change handler:', error);
            }
          };

          // Watch pack selector radio buttons - use both name and class selectors
          const attachPackSelectorListeners = () => {
            const packSelectorRadios = document.querySelectorAll(`.main-product-form[data-product-id="${this.productId}"] input[name="pack_selector"], .main-product-form[data-product-id="${this.productId}"] .pack-selector-radio`);
            packSelectorRadios.forEach(radio => {
              try {
                radio.addEventListener('change', handleChange);
                radio.addEventListener('click', handleChange);
              } catch (error) {
                // Ignore errors
              }
            });
          };

          // Watch main form quantity input as primary method (since pack selector updates this)
          const attachQuantityInputListener = () => {
            const mainQuantityInput = document.querySelector(`.main-product-form[data-product-id="${this.productId}"] input[name="quantity"]`);
            if (mainQuantityInput) {
              mainQuantityInput.addEventListener('change', handleChange);
              mainQuantityInput.addEventListener('input', handleChange);
              
              // Also watch for value changes using MutationObserver
              const observer = new MutationObserver(() => {
                handleChange();
              });
              observer.observe(mainQuantityInput, {
                attributes: true,
                attributeFilter: ['value'],
                childList: false,
                subtree: false
              });
            }
          };

          // Attach listeners immediately
          attachPackSelectorListeners();
          attachQuantityInputListener();

          // Watch for form changes
          if (this.productFormActions) {
            this.productFormActions.addEventListener('change', handleChange);
            this.productFormActions.addEventListener('click', handleChange);
          }
          if (this.mainProductInfo) {
            this.mainProductInfo.addEventListener('change', handleChange);
            this.mainProductInfo.addEventListener('click', handleChange);
          }

          // Periodic check as fallback (in case elements aren't ready yet)
          const checkInterval = setInterval(() => {
            updateQuantity();
            // Re-attach listeners in case elements were added dynamically
            attachPackSelectorListeners();
            attachQuantityInputListener();
          }, 500);

          // Stop checking after 10 seconds
          setTimeout(() => {
            clearInterval(checkInterval);
          }, 10000);

          // Watch for DOM changes to catch dynamically added elements
          const formElement = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
          if (formElement) {
            const domObserver = new MutationObserver(() => {
              attachPackSelectorListeners();
              attachQuantityInputListener();
              updateQuantity();
            });
            domObserver.observe(formElement, {
              childList: true,
              subtree: true,
              attributes: false
            });
          }
        } catch (error) {
          console.log('Error in syncQuantityFromPackSize:', error);
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
          try {
            this.syncQuantityFromPackSize();
          } catch (error) {
            console.log('Error syncing quantity on variant change:', error);
          }
        });
      }
    }
  );
}